import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = { height: { lg: '66.1rem' } }
